/**
 * Golf's own way of writing a score against par: E for level, a sign otherwise.
 *
 * **Done on the string, never on a number.** The value is an exact decimal
 * (Constitution III), and parsing it to position a sign would reintroduce in the
 * browser the arithmetic the server exists to get right.
 */
export function toPar(value: string | number): string {
  const s = String(value)
  if (/^-?0+(\.0+)?$/.test(s)) return 'E'
  return s.startsWith('-') ? s : `+${s}`
}

/** A total with its score against par beside it: "44 (+8)", "25 (-11)". */
export function withToPar(total: string | number | null, par: string | number | null): string {
  if (total === null) return '—'
  return par === null ? String(total) : `${total} (${toPar(par)})`
}
